import React, { Component } from 'react'
import { Provider } from 'mobx-react'

import CarSel from './components/CarSel'
import CitySel from './components/CitySel'
import MiniHeader from './components/MiniHeader'
import CopyRight from './components/CopyRight'
import Header from './components/Header'
import LzLay from './components/LzLay'
import Discount from './components/Discount'
import HotFloor from './components/HotFloor'
import RankFloor from './components/RankFloor'
import PlayFloor from './components/PlayFloor'
import VoucherFloor from './components/VoucherFloor'
import PickFloor from './components/PickFloor'
import ShopFloor from './components/ShopFloor'
import Dialog from './components/Dialog'

import CityInfo from './stores/CityInfo'
import CarInfo from './stores/CarInfo'
import LzLayState from './stores/LzLayState'
import DialogInfo from './stores/DialogInfo'

class App extends Component {
  render() {
    return (
      <Provider cityInfo={CityInfo} carInfo={CarInfo} lzLayState={LzLayState} dialogInfo={DialogInfo}>
        <div>
          <MiniHeader />
          <Header />
          <PickFloor />
          <HotFloor />
          <RankFloor />
          <ShopFloor />
          <Discount />
          <PlayFloor />
          <VoucherFloor />

          <LzLay />
					<CarSel />
					<CitySel />
          <Dialog />
          <CopyRight />
        </div>
      </Provider>
    )
	}
}

export default App


// WEBPACK FOOTER //
// ./src/App.js